import { useEffect, Fragment } from 'react';

import { RepresentativesContainer } from 'src/containers/Escrow/Representatives';
import { usePartySuggestChanges } from 'src/context/suggest-changes';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { AgreementFormEnum } from 'src/graphql/schema';

import { PartyOrganization, SubmitChangesDialog } from './ui';

const RequestChangesParty = () => {
  const { softwareEscrow } = useSoftwareEscrow();
  const {
    representatives,
    partyType,
    agreementType,
    addRepresentative,
    editRepresentative,
    removeRepresentative,
    undoRepresentative,
    setOrganization: setSuggestedOrganization,
  } = usePartySuggestChanges();
  useEffect(() => {
    const organization = softwareEscrow[partyType];

    setSuggestedOrganization({
      streetNumber: organization?.streetNumber || '',
      street: organization?.street || '',
      city: organization?.city || '',
      postalCode: organization?.postalCode || '',
      region: organization?.region || '',
      country: organization?.country || '',
      companyName: organization?.companyName || '',
      companyWebsite: organization?.companyWebsite || '',
      companyRegistration: organization?.companyRegistrationNumber || '',
    });
  }, []);

  const submit = {
    add: addRepresentative,
    edit: editRepresentative,
    remove: removeRepresentative,
  };

  return (
    <Fragment>
      <PartyOrganization />
      <RepresentativesContainer
        role={partyType}
        currentPolicyRole={{
          update: true,
        }}
        agreementType={agreementType as AgreementFormEnum}
        representatives={representatives}
        submit={submit}
        undoRepresentative={undoRepresentative}
        changesRequested
      />
      <SubmitChangesDialog />
    </Fragment>
  );
};

export default RequestChangesParty;
